import { Action } from '../../../../redux/redux.types';
import { APPLICATION_WEBHOOKS_ACTION_NAMES } from './application-webhooks.actions';
import { ApplicationWebhooksState } from './application-webhooks.types';

const defaultState: ApplicationWebhooksState = {
  isInfoSidebarOpen: false,
  selectedWebhookUrl: '',
};

export const applicationWebhooks = (
  state: ApplicationWebhooksState = defaultState,
  { type, payload }: Action,
) => {
  switch (type) {
    case APPLICATION_WEBHOOKS_ACTION_NAMES.SHOW_INFO_SIDEBAR: {
      return {
        isInfoSidebarOpen: true,
        selectedWebhookUrl: payload,
      };
    }

    case APPLICATION_WEBHOOKS_ACTION_NAMES.HIDE_INFO_SIDEBAR: {
      return {
        isInfoSidebarOpen: false,
        selectedWebhookUrl: '',
      };
    }

    default: {
      return state;
    }
  }
};
